import React from 'react';
import type { SectionConfig } from '../../types/settings';
import { Section } from './Section';

interface SuperSectionProps {
  sections: SectionConfig[];
}

export function SuperSection({ sections }: SuperSectionProps) {
  return (
    <>
      {sections
        .filter((section) => section.render !== false)
        .map((section, index) => (
          <Section key={`${section.name}-${index}`} config={section} />
        ))}
    </>
  );
}
